import React from 'react';
import '../../styles/CertificateTable.css';

function CertificateTable({ certificates }) {
  return (
    <div className="certificate-table-container">
      <h2>Your Certificates</h2>
      <table>
        <thead>
          <tr>
            <th>Certificate Name</th>
            <th>Issuer</th>
            <th>Month/Year</th>
            <th>Upload Certificate (PDF)</th>
            <th>Major Lessons</th>
          </tr>
        </thead>
        <tbody>
          {certificates.map((cert, index) => (
            <tr key={index}>
              <td>{cert.name}</td>
              <td>{cert.issuer}</td>
              <td>{cert.monthYear}</td>
              <td><a href={cert.link} target="_blank" rel="noopener noreferrer">{cert.link.includes('google.drive') ? 'View' : 'Issued'}</a></td>
              <td>{cert.lessons}</td>
            </tr>
          ))}
          {certificates.length === 0 && (
            <tr><td colSpan="5">No certificates added yet.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default CertificateTable;